import React from 'react';
import { CreateForm, FormTemplateProps } from 'framework/form';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import useCandidateNoteService from '../candidateNoteService';
import NoteForm from 'domain/recruiting/candidate/Timeline/note/shared/form/NoteForm';

interface CreateNoteFormProps extends Omit<FormTemplateProps, 'children'> {
  onCancel: () => void;
}

const CreateNoteForm = ({ submitFormFunc, onCancel, ...props }: CreateNoteFormProps) => {
  const { getValidationSchema } = useCandidateNoteService();

  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getValidationSchema} {...props}>
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <NoteForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateNoteForm;
